/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Home',
	homePageTabsLabel: 'Home content',
	myContent: 'My content',
	teamContent: 'Team content',
	folder: 'Folder',
	files: 'Files',
	actionMenu: 'Action menu',
	myFolder: 'My Folders',

	emptyFolderNoContent: 'No content',

	//EmptyStates
	emptyRecentTitle: 'You haven\'t viewed any content recently.',
	emptyStateTitle: 'Start by adding data',
	emptyStateBody: 'Click Upload data above or drag and drop to upload data.',
	emptySearchResultTitle: 'Hmm, your search didn\'t return any results.',
	emptyPortalTitle: 'No portals',
	emptyPortalBody: 'You don\'t currently have any portals.',
	emptyWsProjectTitle: 'Start by creating a notebook in Watson Studio.',
	emptyWsProjectBody: 'When you return to Cognos Analytics, your notebook will appear here.',
	emptyFilteredResultTitle: 'Hmm, the applied filters didn\'t return any results.',
	emptyDialogViewTitle: 'No items',
	removeFromRecents: 'Remove from recent',

	// Welcome Banner
	welcomeBannerGreeting: 'Hello. Welcome to Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson empowers users with AI-driven self-service analytics. See how automated data preparation, data discovery and visualizations can drive more confident decisions.',
	welcomeBannerDescription_trialUser: 'You can get started right away by taking a look at our introduction video, product tour and Getting Started tab.',
	takeTourButtonLabel: 'Take a product tour',
	watchVideoButtonLabel: 'Watch video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Are you sure you want to to turn off the welcome banner from your home page? You can turn this back on in Profile and settings > Settings > General at any time. ',
	hideWelcomeBannerTitle: 'Turn off welcome banner',
	ok: 'OK',
	cancel: 'Cancel',
	warn: 'Warning',
	//howto video dialog
	modal_how_title: 'Watch Cognos Analytics overview',
	modal_overview_title: 'Watch Cognos Analytics overview',
	modal_how_play: 'Play video',
	modal_how_video_title_overview: 'Overview',
	modal_how_video_title_getStarted: 'Getting started in 11.2',
	modal_how_video_title_newUI: 'Welcome to the new Cognos experience',
	modal_how_video_title_dataModule: 'Data modules overview',
	modal_how_video_title_explore: 'Data exploration overview',
	modal_how_video_title_dashboard: 'Interactive dashboards overview',
	modal_how_video_title_reporting: 'Reporting overview',
	modal_how_video_title_mobile: 'The power of Cognos in the palm of your hand',

	// Toolbar
	search: 'Search',
	addFolder: 'Add folder',
	addLink: 'Add link',
	filter: 'Filter',
	sort: 'Sort',
	settings: 'Settings',
	tilesView: 'Tiles view',
	listView: 'List view',
	columnView: 'Column view',
	backToSearch: 'Back to search results',

	// Toolbar Actions
	sortBy: 'Sort by',
	sortOrder: 'Order',
	name: 'Name',
	modifiedTime: 'Modified',
	type: 'Type',
	ascending: 'Ascending',
	descending: 'Descending',
	resetSort: 'Reset sort',

	filterType: 'Type',
	filterModificationTime: 'Modified',
	all: 'All',
	today: 'Today',
	yesterday: 'Yesterday',
	pastWeek: 'Past week',
	pastMonth: 'Past month',
	resetFilters: 'Reset filters',
	resultLimit: 'Result limit',

	filterSearchPlaceHolder: 'Filter by keywords',

	resetFilterTag: 'Click X to reset filters.',
	filterTagToolTip: 'Filters applied: %{appliedFilters}.',

	folderName: 'Folder name',
	addAFolder: 'Add a folder',
	add: 'Add',
	error: 'Error',
	newFolderDefaultName: 'New Folder',
	toastCreateNewFolder: '%{nameOfFolder} folder was created in %{tabName}.',
	folderAdded: 'Folder added',
	refresh: 'Refresh',
	openFolder: 'Open folder',

	addAUrl: 'Add a URL',
	linkName: 'URL name',
	linkNamePlaceholder: 'Add URL name',
	linkDescription: 'Description (optional)',
	linkDescriptionPlaceholder: 'Add a description',
	linkUri: 'URL',
	linkUriPlaceholder: 'Add a URL with an acceptable domain',
	acceptableDomains: 'Acceptable domains',
	viewAcceptableDomains: 'View acceptable domains',
	mandatoryField: 'Mandatory field',
	linkAdded: 'URL added',
	toastCreateNewLink: '%{nameOfLink} was added to %{tabName}.',
	noEntries: 'There are no entries in the acceptable domains list. Contact your administrator.',
	unacceptableDomain: 'Your URL uses an invalid domain. Click \'View acceptable domains\' to see a list of domains you can use.',

	compact: 'Compact',
	short: 'Short',
	default: 'Default',
	rowSize: 'Row size',

	// GroupyByTypes
	folders: 'Folders',
	reports: 'Reports',
	dashboards: 'Dashboards',
	data: 'Data',
	packages: 'Packages',
	explorations: 'Explorations',
	stories: 'Stories',
	notebooks: 'Notebooks',
	others: 'Other',

	// Error Messages
	itemsOverLimit: 'The specified name "%{itemName}" has exceeded the maximum (20) limit. Please specify a different name to continue.',
	errorMessageLengthFolderName: 'Please enter a folder name that does not exceed 255 characters.',
	errorMessageLengthLinkName: 'Please enter a link name that does not exceed 255 characters.',
	toastLaunchPerspectiveError: 'Cannot open %{objectType}.',
	errorNoAccessTitle: 'Hmm, it appears you don\'t have access to this content',
	errorNoAccessBody: 'Contact your administrator or refer to the following link:',
	errorEnableExternalContent: 'Enabling external content',

	//TableHeader
	lastAccessed: 'Last Accessed',
	location: 'Location',
	tenant: 'Tenant',

	// GetStartedTab
	getStartedLabel: 'Get up and running in IBM Cognos Analytics',
	learningHowToLabel: 'Learning resources',
	learningHowToDescription: 'Expand your knowledge and get assistance by connecting with the community, reading documentation, and watching videos.',
	learningHowToActionLabel: 'Launch the learn pane',
	howToVideosLabel: 'How-to videos',
	howToVideosDescription: 'Learn how to use IBM Cognos Analytics and start gaining insights into your data.',
	howToVideosActionLabel: 'Watch videos',
	acceleratorCatalogLabel: 'Accelerator Catalog',
	acceleratorCatalogDescription: 'Browse a growing catalog of industry use, best practice guides, custom visualizations, and more.',
	acceleratorCatalogActionLabel: 'Browse catalog',
	sampleSectionTitle: 'Samples',
	sampleSectionDescription: 'Experiment with examples that show off all that Cognos Analytics has to offer.',
	// Samples Section
	createDashboardSampleTitle: 'How to create your first dashboard',
	createDashboardSampleDescription: 'Begin your analytics journey with Cognos Dashboards.',
	nlaSampleTitle: 'Sample Report',
	nlaSampleDescription: 'Explore what is possible with Cognos Analytics Reports with this example analyzing year-end loyalty card member activity.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Expand your visualization library with custom visualizations like the Sankey Chart.',
	viewAllSamplesActionLabel: 'View all samples',
	byFeatureTitle: 'By feature',
	byFeatureDescription: 'Browse samples by feature, such as core functionality, custom controls, extensions, notebooks, and relative dates.',
	byIndustryTitle: 'By industry',
	byIndustryDescription: 'Browse samples by industry, such as automotive, banking and more.',
	// SamplesTab
	sampleTabTitle: 'Get inspired with our prebuilt samples',
	sampleTabLabel: 'Visit the Accelerator Catalog for more samples and extensions from IBM, partners, and customers',

	// quickLaunch
	quickLaunchLabel: 'Quick launch',
	expand: 'Expand',
	collapse: 'Collapse',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Start by choosing what you want to create.',

	// contentPageView
	contentPageTitleLabel: 'Content',
	uploadFile: 'Upload data',
	new: 'New',
	create: 'Create',
	more: 'More',

	// open dialog
	selectDataSourcesToAdd: 'Select data source(s) to add.',
	openDialogDefaultTitle: 'Open',

	// save dialog
	save: 'Save',
	saveAs: 'Save as',
	saving: 'Saving...',
	selectedDestination: 'Selected destination: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' already exists with a different type. Please choose a different name.',
	confirmOverwriteTitle: 'Confirm replacement of existing data',
	confirmOverwriteMsg: 'The file \'%{nameOfFile}\' already exists. Do you want to replace its data with the data contained in the selected file?',

	// copy move dialog
	copy: 'Copy',
	move: 'Move',
	copyOrMove: 'Copy or move: ',
	copyOnly: 'Copy ',
	createShortcut: 'Create shortcut',
	createShortcutDialogTitle: 'Create shortcut: ',

	// External asset types
	wsProject: 'Watson Studio project',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Package',
	dataModule: 'Data module',
	exploration: 'Exploration',
	mode: 'Mode',
	live: 'Live',
	snapshot: 'Snapshot',
	noSnapshotsFound: 'No Snapshot found',
	uploadedFile: 'Uploaded file',
	fileUpload: 'Upload data',
	dataSetEx: 'Data set',
	externalRepository: 'External repository',
	queryMode: 'Query mode',
	queryModeCompatible: 'Compatible',
	queryModeDynamic: 'Dynamic',
	report: 'Report',
	activeReport: 'Active Report',
	query: 'Query',
	analysis: 'Analysis',
	dashboard: 'Dashboard',
	dashboardTemplate: 'Dashboard template',
	jupyterNotebook: 'Notebook',
	wsNotebook: 'Watson Studio notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Story',
	workspace: 'Workspace',
	pagelet: 'Page',
	content: 'Content',
	directory: 'Namespaces',
	dataSet: 'Data set',
	powerPlayCube: 'PowerPlay Cube',
	powerPlayReport: 'PowerPlay Report',
	powerPlay8Report: 'PowerPlay Report',
	setPowerPlay8ReportOptions: 'Set PowerPlay Report Options',
	powerPlay8ReportView: 'PowerPlay Report View',
	reportTemplate: 'Report Template',
	packageConfigurations: 'Package Configuration',
	agent: 'Agent',
	agentDefinition: 'Agent Definition',
	agentDefinitionView: 'Agent View',
	dataMovementTask: 'Data Movement Task',
	dataMovementTaskAlias: 'Data Movement Task Alias',
	document: 'Document',
	DocumentRetention: 'Document properties',
	jobDefinition: 'Job Definition',
	job: 'Job',
	jobs: 'Jobs',
	metricsDataSourceETLTask: 'Metrics Data Source ETL Task',
	metricsExportTask: 'Metrics Export Task',
	metricsFileImportTask: 'Metrics File Import Task',
	metricsMaintenanceTask: 'Metrics Maintenance Task',
	planningTask: 'Planning Task',
	shortcut: 'Shortcut',
	shortcuts: 'Shortcuts',
	URL: 'URL',
	launchable: 'Launchable',
	dataSetFolder: 'Data Set Folder',
	ViewAccessibleLabel: 'View %{label}',
	overrideReportOptions: 'Override the default report options',
	formats: 'Formats',
	saveReport: 'Save the report',
	reportView: 'Report View',
	reportviews: 'Report Views',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel Data',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Role',
	namespace: 'Namespace',
	namespaceFolder: 'Namespace Folder',
	adminFolder: 'Admin Folder',
	//Details
	details: 'Details',
	open: 'Open',
	created: 'Created',
	modified: 'Modified',
	owner: 'Owner',
	dataSource: 'Data Source',
	share: 'Share',
	addToFavorites: 'Add to favorites',
	properties: 'Properties',
	detailsEmptyStateBody: 'Select an item to view its details',
	editNameAndDescription: 'Edit name and description',
	none: 'None',
	setPdfOptions: 'Set PDF options',
	runOptions: 'Run options',

	//rename dialog
	nameInvalid: 'Name is invalid',
	namePlaceholder: 'Enter a name',
	description: 'Description',
	descriptionInvalid: 'The description cannot exceed 350 characters.',
	descriptionPlaceholder: 'Enter a Description',
	errorMessageApostropheError: 'Please enter a file name that does not contain both \' and \" characters',
	renameCollisionError: '%{name} already exists. Try a different name.',
	unknownRenameError: 'Item rename failed. Contact your administrator for further assistance.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Unable to open the specified folder.',

	//Upload
	uploadToFolder: "Upload to <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Upload to <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> and launch%{launchAction}",
	quickUpload: "Quick upload",
	quickUploadAndLaunch: "Drag and drop files to upload to <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> and open in one of the following spaces.",
	unsupportedFilesSingle: "%{files} did not upload because it is invalid for Quick launch.",
	unsupportedFilesMultiple: "The files did not upload because all the files you select must be valid to use Quick launch.",
	unsupportedFilesSingleInvalid: "%{files} is invalid.",
	unsupportedFilesMultipleInvalid: "%{files} are invalid.",
	supportedFileTypes: "Only the following file types are allowed: %{extensions}.",
	uploadDragAndDrop: "Drag and Drop",
	uploadDragAndDropMessage: "Drag and drop your file here to upload it to <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Search criteria \'%{searchTerm}\' was saved.',
	searchWasntSaved: 'Search criteria \'%{searchTerm}\' wasn\'t saved.',
	searchSuggestions: 'Suggestions',
	savedSearch: 'Saved searches',
	searchWasDeleted: 'Search criteria \'%{searchTerm}\' was deleted.',
	searchWasntDeleted: 'Search criteria \'%{searchTerm}\' wasn\'t deleted.',
	savedBarTitle: 'Search Cognos Analytics',
	searchContentPageTitle: 'Search',
	searchContentPageTitleLabel: 'Showing results for \'%{searchTerm}\'',
	showingSearchRsult: 'Showing %{resultCount} items',
	saveSearch: 'Save search',
	saveTenSearches: 'You can save 10 searches.',
	deleteASearch: 'Delete one to save another.',
	close: 'Close',
	allContent: 'All Content',
	searchResultIn: 'Search results in: ',
	//recent view
	recents: 'Recent',
	noAccessRecent: 'No access',
	noAccessRecentMsg: 'You don\'t have access to this asset. It might have been disabled or deleted, or your permissions might have been reduced. Verify the state of the asset at its expected source location. You can remove the asset from your recent items by clicking OK.',
	noAccessMsg: 'You don\'t have access to this asset. It might have been disabled or deleted, or your permissions might have been reduced.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} items selected',
	itemSelected: '%{nameOfSelection} item selected',

	//properties
	general: 'General',
	schedule: 'Schedule',
	permission: 'Permissions',
	capabilities: 'Capabilities',
	propertiesTabsLabel: 'Properties content',
	searchPath: 'Search path',
	id: 'ID',
	language: 'Language',
	setLanguage: 'Set language',
	entryOptions: 'Entry options',
	setPackage: 'Set package or module',
	sourcePackage: 'Source package or data module',
	associatedSourceAgent: 'Source package',
	setAssociatedSourceAgent: 'Set package',
	sourceAgent: 'Source agent',
	setSourceAgent: 'Set source agent',
	setCapabilities: 'Set capabilities',
	disableEntry: 'Disable this entry',
	hideEntry: 'Hide this entry',
	permissions: 'Permissions',
	promptForValues: 'Prompt for values',
	yes: 'Yes',
	no: 'No',
	setValues: 'Set values',
	moreOptions: 'More options',
	reportFormat: 'Report Format',
	enableAccessibilitySupport: 'Enable Accessibility support',
	displayOfRunHistory: 'Display of run history',
	occurrences: 'Occurrences',
	days: 'Day(s)',
	months: 'Month(s)',
	displayOfReportOutputVersions: 'Display of report output versions',
	defaultDisplayOfPortalAction: 'Default portal action',
	viewMostRecentReport: 'View most recent report',
	runTheReport: 'Run the report',
	openWithReportStudio: 'Open with Report Studio',
	rowsPerPageInHtmlReports: 'Rows per page in HTML reports',
	enableSelectionBasedInteractivity: 'Enable selection-based interactivity',
	enableAlertsAboutNewVersions: 'Enable alerts about new versions',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Enable enhanced user features in saved output versions',
	enableCommentsInSavedOutputVersions: 'Enable comments in saved output versions',
	run: 'Run',
	runWithUsersCredentials: 'With user\'s credentials',
	runWithOwnerCapabilities: 'With owner capability',
	runAsOwner: 'As %{ownerName}',
	actionLabelOn: 'On',
	actionLabelOff: 'Off',
	openReport: 'Edit',
	openAnalysis: 'Open with Analysis Studio',
	openQuery: 'Open with Query Studio',
	openPowerPlay8Report: 'Open with PowerPlay Studio',
	openInteractiveReport: 'Edit',
	read: 'Read',
	write: 'Write',
	execute: 'Execute',
	setPolicy: 'Set Policy',
	full: 'Full',
	traverse: 'Traverse',
	grant: 'Grant',
	deny: 'Deny',
	permissionCustom: 'Custom',
	permissionDetailsColumnAccess: 'Access',
	permissionDetailsColumnPermission: 'Permission',
	permissionDetailsColumnAction: 'Action',
	permissionSetAccess: 'Set access',
	permissionRead: 'Read',
	permissionRun: 'Run',
	permissionWrite: 'Write',
	permissionFull: 'Full',
	unavailable: 'Unavailable',
	unkownSource: 'Unknown, open report for details',
	tenantSettings: 'Tenant settings',
	tenantSet: 'Tenant updated',
	tenantSetError: 'Error setting tenant',
	tenantClear: 'Tenant cleared',
	tenantClearError: 'Error clearing tenant',
	shortcutTo: 'Shortcut to',
	sourceReport: 'Source report',
	setSourceReport: 'Set source report',
	setSourceLocation: 'Set Source %{itemName} Location',
	linkPackageOrModule: 'Link the %{itemName} to a package or data module',
	linkPackage: 'Link the %{itemName} to a package',
	externalRepositories: 'External repositories',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Refreshed time',
	size: 'Size',
	tenantsWarningMessage: 'Changing the tenant of an entry also changes the tenant of child entries.',
	confirmClearTenantText: 'Clearing the value to \'None\' may allow other tenants to access the content. Click OK to make the entry public or Cancel to keep the current tenant.',
	confirmClearTenant: 'Confirm clear tenant',
	currentValues: 'Current values',
	emptyPromptValues: 'There are currently no values',
	editValues: 'Edit values',
	clear: 'Clear',
	source: 'Source',
	dataRefreshed: 'Data refreshed',
	//PDF options
	pdfOptions: 'PDF options',
	set: 'Set',
	portrait: 'Portrait',
	landscape: 'Landscape',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Orientation',
	pageDefination: 'Paper size',
	openPasswordRequired: 'Require password to open report',
	accessPasswordRequired: 'Require password to access report',
	emptyPassword: 'Password cannot be empty',
	password: 'Password',
	enterPassword: 'Enter password',
	confirmPassword: 'Confirm password',
	passwordMatchError: 'Passwords don\'t match',
	gateway: 'Gateway',
	pageLayout: 'Page Layout',
	pageStyle: 'Style',
	setUrl: 'Set URL',
	numberRows: 'Number of rows',
	numberColumns: 'Number of columns',
	timeToRefresh: 'Time to refresh',
	lastRefreshedBy: 'Refreshed by',
	unknown: 'Unknown',
	unknownUpdateError: 'Item update failed. Contact your administrator for further assistance.',
	editQuery: 'Edit Query',
	greaterOrEqual: 'Greater than or equal to %{upperboundValue}',
	lessOrEqual: 'Less than or equal to %{lowerboundValue}'
});
